/**
 * Adapts the active rendering platform's complete HTML entity parser to a
 * callback that can be passed into platform-independent schema builders.
 * Angular's injected DOCUMENT is browser-backed on the client and Domino-backed
 * during SSR; callers should avoid constructing this adapter when it is unused.
 */
export function createHtmlEntityDecoder(document: Document): (value: string) => string {
  const textarea = document.createElement('textarea');
  return (value: string) => {
    textarea.innerHTML = value;
    return textarea.value;
  };
}
